import React from 'react';
import PropTypes from 'prop-types';
import { Box, TablePagination } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import TablePaginationActions from "./helper/TablePagination";
import { ROW_SIZE } from "../../utils/constants";
import { setPageNumber, setRowsPerPage } from "../../reduxToolkit/reducers/searchFilterSlice";

const CustomPagination = ({ count, rowsPerPageOptions = ROW_SIZE, rowsPerPage = 50 }) => {
  const dispatch = useDispatch();
  const pageNumber = useSelector((state) => state.searchFilter.pageNumber);
  const zeroBasedPage = pageNumber - 1;

  const handlePageChange = (event, newPage) => {
    dispatch(setPageNumber(newPage + 1));
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    dispatch(setRowsPerPage(newRowsPerPage));
    dispatch(setPageNumber(1));
  };

  const paginatedFrom = (pageNumber - 1) * rowsPerPage + 1;
  const paginatedTo = Math.min(pageNumber * rowsPerPage, count);

  return (
    <> {count > 0 &&
      <Box className="print-none">
        <TablePagination
          component="div"
          count={count}
          page={zeroBasedPage}
          onChangePage={handlePageChange}
          rowsPerPage={rowsPerPage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          ActionsComponent={TablePaginationActions}
          rowsPerPageOptions={rowsPerPageOptions}
          labelDisplayedRows={() => `${paginatedFrom}-${paginatedTo} of ${count}`}
        />

      </Box>
    }
    </>
  );
};

CustomPagination.propTypes = {
  count: PropTypes.number,
  rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
  rowsPerPage: PropTypes.number,
};

export default CustomPagination;
